/*
 * 値札のコンポーネントとしてPriceLabel（現ItemDisplayPrice）を作成したが、
 * コンポーネントの高さがページごとにまちまちだったので、高さを揃えられないかとデザイナーさんに相談した。
 * 結果、まずはコーデ詳細、アイテム詳細、着用アイテム詳細の値札の高さを18pxに揃えることになった。
 * 徐々にフォルダ詳細や画像検索ページなども今後はこちらのPriceLabelに差し替えていきたい。
 *
 * リプレイスデザイン定例のコンフル
 * https://zozo.rickcloud.jp/wiki/pages/viewpage.action?pageId=472927421#:~:text=%E3%83%95%E3%82%A9%E3%83%AB%E3%83%80%E3%80%81%E3%82%A2%E3%82%A4%E3%83%86%E3%83%A0%E4%B8%80%E8%A6%A7%E3%81%AB,%E3%81%A7%E3%81%8A%E9%A1%98%E3%81%84%E3%81%97%E3%81%BE%E3%81%99
 */

const colors = {
  primary: 'bg-blue-500',
  secondary: 'bg-fleamarket',
}
type Color = keyof typeof colors

const sizes = {
  medium: 'leading-[18px] text-[12px] xl:text-[11px]',
  large: 'leading-[22px] text-[13px]',
}
type Size = keyof typeof sizes

type Props = {
  displayPrice: string
  color?: Color
  size?: Size
}

export const PriceLabel: React.FC<Props> = ({
  displayPrice,
  color = 'primary',
  size = 'medium',
}) => (
  <span
    className={`inline-block rounded-[2px] px-[6px] text-white xl:px-2 ${colors[color]} ${sizes[size]}`}
  >
    {displayPrice}
  </span>
)
